import React, { useState } from "react";
import BennyForm from "../BennyForm";
import arrowIcon from "../../images/home/arrow-icon.svg";
import ellipticalIcon from "../../images/individual/ellipticalIcon.svg";
import rightVector from "../../images/individual/right-vector.svg";
import benifitIcon from "../../images/individual/benifitIcon.png";
import permanentIcon from "../../images/individual/permanent-resident.svg";
import helpIcon from "../../images/individual/helpIcon.svg";
import { FaPlus, FaTimes } from "react-icons/fa";
import unlimitedIcon from "../../images/individual/ic_outline-home-work.svg";
import iconPeople from "../../images/individual/akar-icons_people-group.svg";
import checkmarkSeal from "../../images/employee/checkmark-seal.svg";
import helpImmiget from "../../images/individual/benny.jpg";
import { Helmet } from "react-helmet-async";
import BenyHeader from "./BenyHeader";

const BenyPartnership = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  return (
    <div>
      <Helmet>
        <title>Immiget Global & Beny Partnership – Expert Migration Services</title>
        <meta
          name="description"
          content="Discover our exclusive partnership with Beny, offering 15% off all services and comprehensive support beyond visas including skill assessment, settlement, vacation, and talent inheritance."
        />
      </Helmet>
      <BenyHeader />
      <div className="w-full h-90 font-Hellix bg-cover bg-center bg-image">
        <div className="max-w-[1440px] px-4 md:px-[75px] m-auto h-full">
          <div className="flex flex-col gap-2 md:gap-2 pt-10 md:pt-20 pb-[90px] h-full justify-center">
            <h1 className="text-white hellix-font text-center font-semibold text-[22px] md:text-[54px]">
              Visas. Strategy. Success.<br />
              All in one place.
            </h1>
            <div className="flex justify-center gap-2 md:gap-4">
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium">
                HOME
              </div>
              <div className="flex items-center">
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
              </div>
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium uppercase">
                For Employers
              </div>
              <div className="flex items-center">
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
              </div>
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium uppercase">
                Beny Partnership
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Partnership Overview */}
      <div className="xl:flex gap-4 justify-center container max-w-1440px mx-auto px-4 py-4 md:py-10 lg:px-14">
        <div className="xl:w-[50%]">
          <h1 className="xl:text-[30px] text-[24px] max-xl:text-center text-blue mt-6 font-semibold hellix-font">
            Expert Migration Services with a People-First Approach
          </h1>
          <div className="max-xl:text-center hellix-font text-blue text-lg xl:text-[20px] font-normal">
            Whether you're an individual chasing new opportunities or an employer building a global workforce, Immiget Global delivers expert migration services with a people-first approach. Now, through our exclusive partnership with Beny, we're taking support beyond visas — helping clients and companies create success stories for skill assessment, settlement, vacation, or talent inheritance.
          </div>
          <div className="max-xl:text-center mt-6 mb-6">
            <div className="relative inline-block max-w-[90%] xl:max-w-[85%]">
              <div className="absolute inset-0 bg-gradient-to-r from-blue/20 to-[#4dabf7]/30 rounded-lg transform -rotate-1 scale-103"></div>
              <div className="relative bg-white border-2 border-blue/30 rounded-lg shadow-lg py-4 px-6 transform hover:scale-102 transition-transform duration-300">
                <p className="hellix-font text-blue text-lg xl:text-[20px] font-normal">
                  Our collaboration reaps many benefits, one of them being availing <span className="font-bold text-[#2E86DE] text-xl xl:text-[26px] animate-pulse">15% OFF</span> on all our services.
                </p>
                <div className="mt-3 flex justify-center">
                  <button>
                    <a onClick={() => {
                    const contactSection = document.getElementById('contact-section');
                    if (contactSection) {
                      contactSection.scrollIntoView({ behavior: 'smooth' });
                    }
                  }} className="bg-blue text-white font-semibold py-2 px-5 rounded-full hover:bg-opacity-90 transition duration-300 flex items-center">
                    <span>Claim Your Discount</span>
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </a>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="xl:w-[50%] max-xl:justify-center max-xl:flex max-xl:mt-4">
          <img src={helpImmiget} alt="Immiget Global Partnership" className="rounded-lg" />
        </div>
      </div>
      
      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>
      
      {/* Real-World Support Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={ellipticalIcon} alt="elliptical" />
          </div>
          <h1 className="lg:text-[28px] text-2xl text-blue font-semibold hellix-font">
            Real-World Support for your aspirations
          </h1>
        </div>
        <div className="text-blue font-normal text-lg lg:text-[20px] mt-2 hellix-font">
          As a team of registered migration experts specializing in migration in Australia, we work with a forward-thinking approach to not only navigate migration pathways but to secure a result that lasts forever.
        </div>
        <div className="text-blue font-semibold text-lg lg:text-[22px] mt-4 hellix-font text-center">
          We make migration simple, clear, and successful.
        </div>
      </div>
      
      {/* What Sets Us Apart */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-6 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={benifitIcon} alt="benefits icon" />
          </div>
          <h1 className="lg:text-[28px] text-2xl text-blue font-semibold hellix-font">
            What Sets Us Apart
          </h1>
        </div>
        
        <div className="lg:ml-4 mt-6">
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg xl:text-[20px] font-normal hellix-font">
              98.9% Visa Approval Rate
            </div>
          </div>
          
          <div className="flex gap-2 mt-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg xl:text-[20px] font-normal hellix-font">
              2100+ Visas Granted
            </div>
          </div>
          
          <div className="flex gap-2 mt-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg xl:text-[20px] font-normal hellix-font">
              600+ Positive Reviews
            </div>
          </div>
          
          <div className="flex gap-2 mt-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg xl:text-[20px] font-normal hellix-font">
              5+ Years of Experience
            </div>
          </div>
          
          <div className="flex gap-2 mt-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg xl:text-[20px] font-normal hellix-font">
              Registered Migration Agents
            </div>
          </div>
          
          <div className="flex gap-2 mt-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg xl:text-[20px] font-normal hellix-font">
              Fast-Tracked Processing & Clear Communication
            </div>
          </div>
        </div>
      </div>
      
      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>
      
      {/* What We Offer */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-6 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={benifitIcon} alt="benefits icon" />
          </div>
          <h1 className="lg:text-[28px] text-2xl text-blue font-semibold hellix-font">
            What We Offer
          </h1>
        </div>
        <div className="text-blue font-normal text-lg lg:text-[20px] mt-2 hellix-font">
          Explore our full range of migration solutions, backed by deep expertise and a commitment to care.
        </div>
        
        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* GSM Visas */}
          <div className="shadow-custom-white p-6 rounded-[16px]">
            <h3 className="text-blue text-xl font-semibold hellix-font mb-2">General Skilled Migration (GSM) Visas</h3>
            <p className="text-blue text-lg font-normal hellix-font">
              For skilled professionals seeking permanent settlement in Australia.<br/>
              Expert guidance through the points-tested visa process, including Subclass 189, 190, and 491.
            </p>
          </div>
          
          {/* Employer Sponsored Visas */}
          <div className="shadow-custom-white p-6 rounded-[16px]">
            <h3 className="text-blue text-xl font-semibold hellix-font mb-2">Employer Sponsored Visas</h3>
            <p className="text-blue text-lg font-normal hellix-font">
              For businesses and skilled workers navigating employer-nominated migration.<br/>
              Secure Subclass 186, 482, 494, 407, 400, and 187 more — with a streamlined, strategic process.
            </p>
          </div>
          
          {/* Visitor Visas */}
          <div className="shadow-custom-white p-6 rounded-[16px]">
            <h3 className="text-blue text-xl font-semibold hellix-font mb-2">Visitor Visas</h3>
            <p className="text-blue text-lg font-normal hellix-font">
              For hassle-free short stays in Australia.<br/>
              We manage every step of the application process for tourists, family visits, or business travel.
            </p>
          </div>
          
          {/* Partner Visas */}
          <div className="shadow-custom-white p-6 rounded-[16px]">
            <h3 className="text-blue text-xl font-semibold hellix-font mb-2">Partner Visas</h3>
            <p className="text-blue text-lg font-normal hellix-font">
              For couples planning their life together in Australia.<br/>
              Comprehensive support for Subclass 820/801 and 309/100 — onshore or offshore.
            </p>
          </div>
          
          {/* Parent Visas */}
          <div className="shadow-custom-white p-6 rounded-[16px]">
            <h3 className="text-blue text-xl font-semibold hellix-font mb-2">Parent Visas</h3>
            <p className="text-blue text-lg font-normal hellix-font">
              Helping parents reunite with children settled in Australia.<br/>
              Navigate complex timelines and requirements with trusted guidance.
            </p>
          </div>
          
          {/* Family Visas */}
          <div className="shadow-custom-white p-6 rounded-[16px]">
            <h3 className="text-blue text-xl font-semibold hellix-font mb-2">Family Visas</h3>
            <p className="text-blue text-lg font-normal hellix-font">
              For family reunification beyond partners and parents.<br/>
              We ensure your loved ones can join you in Australia with minimal delays.
            </p>
          </div>
          
          {/* Skill Assessments & Registration */}
          <div className="shadow-custom-white p-6 rounded-[16px]">
            <h3 className="text-blue text-xl font-semibold hellix-font mb-2">Skill Assessments & Registration</h3>
            <p className="text-blue text-lg font-normal hellix-font">
              For clients needing recognition of skills or the requirement of an expert's assistance to get registered, our team has got your back.
            </p>
          </div>
          
          {/* Temporary Activity Visas */}
          <div className="shadow-custom-white p-6 rounded-[16px]">
            <h3 className="text-blue text-xl font-semibold hellix-font mb-2">Temporary Activity Visas</h3>
            <p className="text-blue text-lg font-normal hellix-font">
              For work, training, or cultural events in Australia.<br/>
              We simplify the Subclass 400 and 408 visa process for individuals and organizations.
            </p>
          </div>
        </div>
      </div>
      
      {/* CTA Section */}
      <div className="container max-w-1440px mx-auto px-4 py-10 lg:px-14">
        <div className="bg-[#F4FFFC] rounded-lg p-8 text-center">
          <h2 className="text-blue text-2xl lg:text-[30px] font-bold hellix-font mb-4">
            LET'S SIMPLIFY MIGRATION FOR YOU
          </h2>
          <p className="text-blue text-lg lg:text-[20px] font-normal hellix-font mb-6">
            Whether you're building a new life or building a global workforce, Immiget Global is your partner. We handle the complexities, so you can focus on what matters most.
          </p>
          <button onClick={() => {
            const contactSection = document.getElementById('contact-section');
            if (contactSection) {
              contactSection.scrollIntoView({ behavior: 'smooth' });
            }
          }} className="inline-block bg-blue text-white font-semibold py-3 px-8 rounded-full hover:bg-opacity-90 transition duration-300">
            Contact Us Today
          </button>
        </div>
      </div>
      <BennyForm />
    </div>
  );
};

export default BenyPartnership;